import { MapData } from "@/shared/types/types";
import { ShapeRootLayer } from "../types/zod";

export function parseMap(mapData: object, mapId: string) {
	const map = mapData as MapData;
	map.id = mapId;
	map.routes = parseJson(map.routes as unknown as string, []);
	map.markers = parseJson(map.markers as unknown as string, []);
	const shapeLayer = parseJson(map.shapeLayer as unknown as string, { shapes: [] } as ShapeRootLayer);
	map.shapeLayer = shapeLayer?.shapes ? shapeLayer : { shapes: [] } as ShapeRootLayer // fix for borked data in db
	return map;
}



export function parseJson(jsonString: string, defaultValue: any): any {
	try {
		const value = JSON.parse(jsonString);
		if (value !== undefined) {
			return value;
		}
	} catch (e) {
		console.log("failed parsing json:", jsonString);
	}
	return defaultValue;
}